import { Stack, Tooltip } from '@mui/material';
import { get } from 'lodash';

import { tableTypes } from '@/shared/components';

import { CellText, ToLinkOrNotToLink, UICustomTableCell } from './components';
import { StyledTableCell } from './ui-table-cell.styled.ts';

type alignProps = 'center' | 'left' | 'right';

const UITableCell = <DataItem, >({
  dataItem,
  column,
}: {
  dataItem: DataItem
  column: tableTypes.ColumnProps<DataItem>
}) => {
  const cellValue = get(dataItem, column.columnKey);
  const Icon = column.cellInfo?.getIcon?.(dataItem) || column.cellInfo?.icon;

  if (column.customCellRenderer && cellValue !== null) {
    return (
      <UICustomTableCell
        dataItem={dataItem}
        column={column}
        Icon={Icon}
        cellValue={cellValue}
        description={column.cellInfo?.description?.(dataItem) || ''}
      />
    );
  }

  return (
    <StyledTableCell
      width={column.width}
      minWidth={column.cellInfo?.hasUnbreakableTextData ? '15rem' : column.minWidth}
      align={column.cellInfo?.alignItems as alignProps || 'left'}
      sx={{
        wordBreak: column.cellInfo?.hasUnbreakableTextData ? 'break-word' : ''
      }}
    >
      <ToLinkOrNotToLink href={column.cellInfo?.href?.(dataItem) || ''}>
        <Tooltip
          arrow
          title={column.cellInfo?.cellTooltipText || ''}
          placement={column.cellInfo?.cellTooltipPlace || 'bottom'}
        >
          <Stack
            alignItems='center'
            flexDirection='row'
            justifyContent={column.cellInfo?.alignItems || 'left'}
          >

            {!!Icon && (
              !column.cellInfo?.iconPosition ||
              column.cellInfo?.iconPosition === 'left'
            ) && (
               Icon
             )}

            {cellValue && (
              <CellText
                title={cellValue}
                description={column.cellInfo?.description?.(dataItem) || ''}
                titleColor={column.cellInfo?.cellTextColor}
                titleWeight={column.cellInfo?.cellTextWeight}
              />
            )}

            {!!Icon && column.cellInfo?.iconPosition === 'right' && (
              Icon
            )}
          </Stack>
        </Tooltip>
      </ToLinkOrNotToLink>
    </StyledTableCell>
  );
};

export default UITableCell;